import { PrivilegeEnum as s } from "@hprofits/shared/auth";
import { HttpStatus as r } from "@hprofits/utils";
import { ocPrivate as t } from "../common/auth/procedure-builders.js";
import "../common/errors/constants.js";
import { notFoundError as m } from "../common/errors/contract.js";
import "../common/errors/schemas.js";
import "../swagger/security.js";
import { SwaggerTags as e } from "../swagger/tags.js";
import { StatSegmentDeleteRequestSchema as n, StatSegmentsResponseSchema as i, StatSegmentUpdateRequestSchema as c, StatSegmentResponseSchema as u, StatSegmentCreateRequestSchema as h, StatQueryGetRequestSchema as T, StatQueryGetResponseSchema as d, StatQuerySaveRequestSchema as g, StatQuerySaveResponseSchema as R, StatReportValuesRequestSchema as I, StatReportValuesResponseSchema as l, StatReportGroupedRequestSchema as C, StatReportGroupedResponseSchema as A, StatReportRequestSchema as p, StatisticsMetricsResponseSchema as S, StatReportDimensionsResponseSchema as y, StatReportsResponseSchema as G, CampaignTotalsRequestSchema as v, CampaignTotalsResponseSchema as D, CampaignRollupRequestSchema as O, CampaignRollupResponseSchema as E, StatisticsMetricsRequestSchema as q, CampaignTimeseriesRequestSchema as f, CampaignTimeseriesResponseSchema as P, StatBusinessRequestSchema as o, StatGroupedResponseSchema as a, MarketplaceDomainsRequestSchema as F, MarketplaceRequestSchema as B, StatChildCountsRequestSchema as N, StatChildCountsResponseSchema as b } from "./schemas.js";
const j = {
  statistics: {
    /**
     * Get domain-level statistics.
     * Backend hardcodes: code=campaign_domains_and_spots, groups=[domain],
     * metrics=[impressions, cpm_10th_percentile, cpm_95th_percentile].
     */
    domains: t([s.ReadAdvert]).route({
      method: "POST",
      path: "/statistics/domains",
      summary: "Get domain statistics",
      tags: [e.STATISTICS.name]
    }).input(o).output(a).errors({}),
    /**
     * Get spot-level statistics (ad units grouped by domain).
     * Backend hardcodes: code=campaign_domains_and_spots,
     * groups=[sys_adunit_number, ad_unit_type, ad_unit_format, traffic_source],
     * metrics=[impressions].
     */
    spots: t([s.ReadAdvert]).route({
      method: "POST",
      path: "/statistics/spots",
      summary: "Get spot statistics",
      tags: [e.STATISTICS.name]
    }).input(o).output(a).errors({}),
    /** Top-level spot statistics without domain grouping (spot-first browse mode). */
    spotsTop: t([s.ReadAdvert]).route({
      method: "POST",
      path: "/statistics/spots-top",
      summary: "Get top-level spot statistics",
      tags: [e.STATISTICS.name]
    }).input(o).output(a).errors({}),
    /** Domain statistics under a spot; the caller passes the `sys_adunit_number` filter. */
    domainsBySpot: t([s.ReadAdvert]).route({
      method: "POST",
      path: "/statistics/domains-by-spot",
      summary: "Get domain statistics for a spot",
      tags: [e.STATISTICS.name]
    }).input(o).output(a).errors({}),
    /** Child keys and totals per parent key, matching `spots` (mode=domain) or `domains-by-spot` (mode=spot). */
    childCounts: t([s.ReadAdvert]).route({
      method: "POST",
      path: "/statistics/child-counts",
      summary: "Get child counts for domains or spots",
      tags: [e.STATISTICS.name]
    }).input(N).output(b).errors({}),
    marketplace: t([s.ReadAdvert]).route({
      method: "POST",
      path: "/statistics/marketplace",
      summary: "Get the marketplace spots of the last 24 hours",
      tags: [e.STATISTICS.name]
    }).input(B).output(a).errors({}),
    marketplaceDomains: t([s.ReadAdvert]).route({
      method: "POST",
      path: "/statistics/marketplace/domains",
      summary: "Get the domains of a marketplace spot over the last 24 hours",
      tags: [e.STATISTICS.name]
    }).input(F).output(a).errors({}),
    /**
     * Get aggregate totals across all domains (no grouping).
     * Backend hardcodes: code=campaign_domains_and_spots, groups=[],
     * metrics=[impressions, cpm_10th_percentile, cpm_95th_percentile].
     */
    totals: t([s.ReadAdvert]).route({
      method: "POST",
      path: "/statistics/totals",
      summary: "Get aggregate totals",
      tags: [e.STATISTICS.name]
    }).input(o).output(a).errors({}),
    /**
     * Get a campaign's per-bucket statistics for the performance chart.
     * Backend hardcodes the campaign filter and the date/hour grouping the period implies.
     * Authorization is delegated to ae-stat: report-role check via X-Active-Role-Id, plus implicit user_id row scoping for non-admins.
     */
    campaignTimeseries: t([s.ReadAdvert]).route({
      method: "POST",
      path: "/statistics/campaign-timeseries",
      summary: "Get campaign timeseries statistics",
      tags: [e.STATISTICS.name]
    }).input(f).output(P).errors({}),
    /**
     * The metrics of a report as ae-stat defines them: key, label, hint, display format and how the total is made.
     * Proxies ae-stat GET /stats/metrics.
     */
    metrics: t([s.ReadAdvert]).route({
      method: "GET",
      path: "/statistics/metrics",
      summary: "Get the metric dictionary of a report",
      tags: [e.STATISTICS.name]
    }).input(q).output(S).errors({}),
    /**
     * Per pricing-rule node totals of one campaign over a date range (one row per node, sub-rules included).
     * Backed by ae-stat grouped by sys_campaign_rollup, filtered by the campaign; access is scoped by ae-stat.
     */
    campaignRollup: t([s.ReadAdvert]).route({
      method: "POST",
      path: "/statistics/campaign-rollup",
      summary: "Get campaign statistics per pricing rule",
      tags: [e.STATISTICS.name]
    }).input(O).output(E).errors({}),
    campaignTotals: t([s.ReadAdvert]).route({
      method: "POST",
      path: "/statistics/campaign-totals",
      summary: "Get statistics totals per campaign",
      tags: [e.STATISTICS.name]
    }).input(v).output(D).errors({}),
    reports: t().route({
      method: "GET",
      path: "/statistics/reports",
      summary: "Get the reports available to the active role",
      tags: [e.STATISTICS.name]
    }).output(G).errors({ FORBIDDEN: { status: r.FORBIDDEN, message: "Forbidden" } }),
    reportDimensions: t().route({
      method: "GET",
      path: "/statistics/report-dimensions",
      summary: "Get the dimensions of a report",
      tags: [e.STATISTICS.name]
    }).input(p).output(y).errors({ FORBIDDEN: { status: r.FORBIDDEN, message: "Forbidden" } }),
    reportMetrics: t().route({
      method: "GET",
      path: "/statistics/report-metrics",
      summary: "Get the metrics of a report",
      tags: [e.STATISTICS.name]
    }).input(p).output(S).errors({ FORBIDDEN: { status: r.FORBIDDEN, message: "Forbidden" } }),
    reportGrouped: t().route({
      method: "POST",
      path: "/statistics/report-grouped",
      summary: "Get grouped statistics of a report",
      tags: [e.STATISTICS.name]
    }).input(C).output(A).errors({ FORBIDDEN: { status: r.FORBIDDEN, message: "Forbidden" } }),
    reportValues: t().route({
      method: "POST",
      path: "/statistics/report-values",
      summary: "Get the values of a report dimension",
      tags: [e.STATISTICS.name]
    }).input(I).output(l).errors({ FORBIDDEN: { status: r.FORBIDDEN, message: "Forbidden" } }),
    saveQuery: t().route({
      method: "POST",
      path: "/statistics/queries",
      summary: "Save the statistics page state behind a short id",
      tags: [e.STATISTICS.name]
    }).input(g).output(R).errors({}),
    getQuery: t().route({
      method: "GET",
      path: "/statistics/queries/{queryId}",
      summary: "Get a saved statistics page state",
      tags: [e.STATISTICS.name]
    }).input(T).output(d).errors({ ...m("Statistics query not found") }),
    segments: t().route({
      method: "GET",
      path: "/statistics/segments",
      summary: "List the saved statistics segments of the user in the active role",
      tags: [e.STATISTICS.name]
    }).output(i).errors({}),
    createSegment: t().route({
      method: "POST",
      path: "/statistics/segments",
      summary: "Save the statistics selection as a named segment",
      tags: [e.STATISTICS.name]
    }).input(h).output(u).errors({}),
    updateSegment: t().route({
      method: "PUT",
      path: "/statistics/segments/{segmentId}",
      summary: "Rename or overwrite a statistics segment",
      tags: [e.STATISTICS.name]
    }).input(c).output(u).errors({ ...m("Statistics segment not found") }),
    deleteSegment: t().route({
      method: "DELETE",
      path: "/statistics/segments/{segmentId}",
      summary: "Delete a statistics segment",
      tags: [e.STATISTICS.name]
    }).input(n).output(i).errors({ ...m("Statistics segment not found") })
  }
};
export {
  j as statisticsContract
};
//# sourceMappingURL=contract.js.map
